import gql from 'graphql-tag';

export default gql`
  query userMenu {
    application(name: DESKTOPBOOKINGPATH) {
      userMenu {
        __typename
        id
        title
        icon
        link {
          __typename
          target
          ... on AbsoluteLink {
            url
          }
          ... on RelativeLink {
            path
          }
        }
        ... on ExpandableMenuItem {
          __typename
          expanded
          items {
            id
            title
            icon
            link {
              __typename
              target
              ... on AbsoluteLink {
                url
              }
              ... on RelativeLink {
                path
              }
            }
          }
        }
      }
    }
  }
`;
